import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
    eventData: object;
    particularEmployeeDetails: object;
    appraiserfeedback: object;
}

const initialState: AuthState = {
    eventData: {},
    particularEmployeeDetails: {},
    appraiserfeedback: {
        "significantachievements": null,
        "improvementareas": null,
        "technicalskills": null,
        "softskills": null,
        "appraisercomments": null
    }

};

const empEventSlice = createSlice({
    name: 'eventData',
    initialState,
    reducers: {
        setEventData: (state, action: PayloadAction<object>) => {
            state.eventData = action.payload;
        },
        clearEventData: state => {
            state.eventData = {};
        },
        setParticularEmployeeData: (state, action: PayloadAction<object>) => {
            state.particularEmployeeDetails = action.payload;
        },
        clearParticularEmployeeData: state => {
            state.particularEmployeeDetails = {};
        },
        storeAppraiserFeedback: (state, action: PayloadAction<any>) => {
            state.appraiserfeedback = action.payload;
        }
    },
});

export const { setEventData, clearEventData, setParticularEmployeeData, clearParticularEmployeeData, storeAppraiserFeedback } = empEventSlice.actions;
export default empEventSlice.reducer;
